//@ts-nocheck
import { GetScriptsOutput } from '../../types'

export function getRebuttals(
  rebuttals: object,
  provider: 'ndr' | 'rga',
  payer: boolean,
  userRole: 'screener' | 'fronter' | 'closer' | '*',
  lang: 'en' | 'es' = 'en',
): GetScriptsOutput {
  //@ts-ignore
  return rebuttals[
    `${lang}_${userRole === '*' ? '' : `${userRole.toLowerCase()}_`}${payer ? 'payer' : 'nonpayer'}_${provider}`
  ]
}
